import type { NnnKenmerkType } from '../types/careplan-nnn.types';

export function kenmerkKey(type: NnnKenmerkType, ref: string): string {
  return `${type}:${ref}`;
}
